<script>
import api from '@/utils/api'
import ApiErrorMixin from '@/mixins/apiErrorMixin'
import BankMixin from '@/mixins/bankMixin'

export default {
  name: 'RelayMixin',
  mixins: [ApiErrorMixin, BankMixin],
  methods: {
    async postRelay (modelData, callback, currentRowData) {
      const model = { ...modelData, 'coordinate': { 'longitude': '55.872230', 'latitude': '37.374115' } }

      try {
        this.showPageLoader()
        const params = { path: 'RELAY_PATH', model }
        const requestResponse = await api.post(params)
        const response = this.checkRelayCreateResponse(requestResponse)
        if (response && response.id) {
          callback(currentRowData)
          this.hidePageLoader()
        } else {
          this.hidePageLoader()
        }
      } catch (error) {
        this.hidePageLoader()
      }
    },
  }
}
</script>
